import { Button } from "antd";
import { useGetPayoutQuery } from "api/TenantSlug/Payout/hooks";
import { ManageTransactionForm } from "components/Forms/ManageTransactionForm/ManageTransactionForm";
import { Drawer } from "components/UI/Drawer";
import { DrawerTitle } from "components/UI/DrawerTitle/DrawerTitle.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { DrawerId, FormType } from "types/models.ts";

interface TransactionReportDetailDrawerProps {
    payoutId: string;
}

export const TransactionReportDetailDrawer: FC<TransactionReportDetailDrawerProps> = ({ payoutId }) => {
    const { t: tDrawer } = usePaldockTranslation("drawers.transaction-report-detail");
    const { t } = usePaldockTranslation("common");
    const drawerId = DrawerId.TransactionReportDetail;

    const getPayoutQuery = useGetPayoutQuery(payoutId);

    if (!getPayoutQuery.data?.payout) {
        return <></>;
    }

    return (
        <Drawer
            drawerId={drawerId}
            title={
                <DrawerTitle
                    mainTitle={tDrawer("title")}
                    subTitles={[getPayoutQuery.data.payout.commission_id, "TODO - OfferName", "TODO - Affiliate Name"]}
                />
            }
            searchParamsToClean={[`${drawerId}-id`]}
            extraButtons={
                <Button size={"large"} type={"primary"}>
                    {t("save")}
                </Button>
            }
        >
            <ManageTransactionForm formType={FormType.Detail} payout={getPayoutQuery.data?.payout} />
        </Drawer>
    );
};
